import { apiClient } from "../../../config/axios.config";
import type { PaginationResponse, Response } from "../../../types/api.types";
import type { createDeviceForm, DEVICE_CATEGORY_TYPE, getDeviceListForm, PARTNER_DEVICE_CATEGORY_TYPE } from "../dtos/request/device.request";
import type { Device } from "../dtos/response/device.response";

const model = "/v1/device";

export const getDeviceList = async (query: getDeviceListForm): Promise<PaginationResponse<Device>> => {
  const { data } = await apiClient.get(model, { params: query });
  return data;
};

export const getDeviceDetail = async (id: string): Promise<Response<Device>> => {
  const { data } = await apiClient.get(`${model}/${id}`);
  return data;
};

export const patchDevice = async (id: string, form: createDeviceForm): Promise<Response> => {
  const { data } = await apiClient.patch(`${model}/${id}`, form);
  return data;
};

export const createDevice = async (form: createDeviceForm): Promise<Response> => {
  const { data } = await apiClient.post(`${model}`, form);
  return data;
};

export const getDeviceQuotationList = async (type: DEVICE_CATEGORY_TYPE): Promise<PaginationResponse> => {
  const { data } = await apiClient.get(`${model}/quotation`, {
    params: { strategy: type },
  });
  return data;
};

/**
 * 제휴용 기종 리스트 (GET /v1/device/fromPartner?category=GALAXY|IPHONE|KIDS)
 * TODO(backend): 응답은 유저앱 /byDailyQuote 와 동일 포맷으로 준다고 함 — 배열/페이지 어느 쪽이든 받도록 정규화
 */
export const getDeviceFromPartner = async (category: PARTNER_DEVICE_CATEGORY_TYPE): Promise<Device[]> => {
  const { data } = await apiClient.get<Response<Device[] | { content: Device[] }>>(`${model}/fromPartner`, {
    params: { category },
  });
  const result = data?.result;
  if (Array.isArray(result)) return result;
  return result?.content ?? [];
};

export const postDeviceColor = async (id: string | number, colorName: string): Promise<Response> => {
  const { data } = await apiClient.post(`${model}/${id}/color`, {}, {
    params: { colorName: colorName },
  });
  return data;
}

export const deleteDeviceColor = async (id: string | number, colorName: string): Promise<Response> => {
  const { data } = await apiClient.delete(`${model}/${id}/color`, {
    params: { colorName: colorName },
  });
  return data;
}
